import React from 'react'
import ReactDatePicker from 'react-datepicker'
import { FormItem, FormItemProps } from './FormItem'
import { IField, getRequiredError } from './FieldValidation'
import { formatDateForDisplay, getDateAsString, getDateFromString } from '../Utility'

export interface DateFieldCallback { (value: string): any }

export interface DateFieldProps extends FormItemProps {
    id: string
    disabled?: boolean
    onChange: DateFieldCallback
    value: string
    required?: boolean
    min?: Date
    max?: Date
    monthOnly?: boolean
    requiredMessage?: string
}

export interface DateFieldState {
    errorMessage?: string
}

export class DateField extends React.Component<DateFieldProps, DateFieldState> implements IField {
  input: ReactDatePicker

  constructor(props?: DateFieldProps, context?: any) {
    super(props, context)

    this.state = {
    }
  }

  componentDidUpdate(prevProps: DateFieldProps, prevState: DateFieldState) {
    if (this.props.value != prevProps.value) {
      if (this.state.errorMessage) {
        this.validate(() => { })
      }
    }
  }

  onChange(v: Date) {
    const dateString = getDateAsString(v);
    const year = v.getFullYear();

    // Check if the year is a four-digit number
    if (year < 1000 || year > 9999) {
      this.setError('Year must be a four-digit number');
    } else {
      this.setError(null, () => {
        this.props.onChange(dateString);
      });
    }
  }


  render() {
    var value = getDateFromString(this.props.value)

    if (this.props.preview) {
      return (
        <FormItem {...this.props} errorMessage={this.props.errorMessage || this.state.errorMessage}>
          <div className="form-value">{formatDateForDisplay(this.props.value, '--')}</div>
        </FormItem>
      )
    }

    return (
      <FormItem {...this.props} inputId={this.props.id} errorMessage={this.props.errorMessage || this.state.errorMessage} >
        <div>
          <ReactDatePicker
            className={'emdg-text-input'
                    + `${(this.props.errorMessage || this.state.errorMessage) ? ' emdg-text-input--invalid' : ''}`}
            id={this.props.id}
            ref={(r) => this.input = r}
            selected={value}
            onChange={(v) => this.onChange(v)}
            dateFormat={this.props.monthOnly ? 'MM/yyyy' : 'dd/MM/yyyy'}
            minDate={this.props.min}
            maxDate={this.props.max}
            disabled={this.props.disabled}
            showMonthYearPicker={this.props.monthOnly}
            autoComplete="off"
          />
        </div>
      </FormItem>
    )
  }

  getFieldType(): string {
    return 'text'
  }

  focus() {
    this.input.setFocus()
  }

  getErrorText(): string {
    if (this.props.required === true) {
      if (!this.props.value) {
        return getRequiredError(this.props)
      }
    }

    if (this.props.value) {
      const value = getDateFromString(this.props.value)
      const year = value.getFullYear()

      // allow only years in the 4-digit range
      if (year < 1000 || year > 9999) {
        return 'Year must be a four-digit number'
      }

      if (this.props.min && value < this.props.min)
        return `Value cannot be less than ${formatDateForDisplay(getDateAsString(this.props.min))}`

      if (this.props.max && value > this.props.max)
        return `Value cannot exceed ${formatDateForDisplay(getDateAsString(this.props.max))}`
    }
    return null
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    let errorText = this.getErrorText()
    this.setError(errorText, () => {
      if (this.props.errorMessage || errorText) {
        if (focus === true) {
          this.focus()
        }
      }
      callback && callback((this.props.errorMessage || errorText) ? false : true)
    })
  }

  setError(errorMessage?: string, callback?: { (): any }) {
    this.setState({ errorMessage }, callback)
  }
}
